import transitionend from './transitionend';
import disableBodyScroll from './toggle-body-scroll';
import { DOCUMENT_ELEMENT } from '../constants';

const eventHandler = {};

export default function (isOpened, scrollableSelector = null, modalElement) {
  function removeClass() {
    if (!DOCUMENT_ELEMENT.classList.contains('booking-menu-opened')) {
      DOCUMENT_ELEMENT.classList.remove('has-modal');
      disableBodyScroll(false, scrollableSelector);
    }
  }

  if (!eventHandler[scrollableSelector]) eventHandler[scrollableSelector] = removeClass;
  if (isOpened) {
    modalElement.removeEventListener('transitionend', eventHandler[scrollableSelector], { once: true });
    DOCUMENT_ELEMENT.classList.add('has-modal');
    disableBodyScroll(true, scrollableSelector);
  } else {
    transitionend(modalElement, 'transitionend', eventHandler[scrollableSelector]);
  }
}



// WEBPACK FOOTER //
// ./scripts/utils/toggle-modal.js